/** Deutsche Namen fuer die Template-Kategorien aus den Vorlagen. */
export const TEMPLATE_KATEGORIEN: Record<string, string> = {
  linkedin_post: 'LinkedIn-Beitrag',
  blog: 'Blog',
  email: 'E-Mail',
  content: 'Inhalt',
  ad: 'Anzeige',
  text: 'Allgemeiner Text',
};

export const kategorieLabel = (k?: string | null) => {
  if (!k) return '—';
  if (TEMPLATE_KATEGORIEN[k]) return TEMPLATE_KATEGORIEN[k];
  const s = k.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
};
